import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HesapPlani } from 'src/model/hesap-plani';
import { RestService } from 'src/providers/rest.service';

declare var $: any;

@Component({
  selector: 'app-hesap-kodu-sec-modal',
  templateUrl: './hesap-kodu-sec-modal.component.html',
  styleUrls: ['./hesap-kodu-sec-modal.component.css']
})
export class HesapKoduSecModalComponent implements OnInit {

  modalData: number = null;
  hesapKoduAra = '';
  hesapAdiAra = '';
  // subeId: number
  hesapPlani: HesapPlani;

  @Output() selectedHesapKodu = new EventEmitter<string>();

  @Input()
  public set show(ts: number) {
    if (ts) {
      if (this.modalData !== ts) {
        this.modalData = ts;
        this.reset();
        $('#hesap-kodu-sec-modal').modal('show');
      }
    }
  }

  // @Input()
  // public set sube(subeId: number) {
  //   if (subeId) {
  //     if (this.subeId !== subeId) {
  //       this.subeId = subeId;
  //     }
  //   }
  // }

  constructor(private restService: RestService, private toastrService: ToastrService) { }

  ngOnInit(): void {
  }

  kodAraInputChange() {
    if (this.hesapAdiAra.length === 0 && this.hesapKoduAra.length === 0) {
      this.toastrService.info("Hesap Kodu ya da Hesap Adı giriniz!", "Uyarı!");
      return;
    }

    this.restService.getHesapPlani(this.hesapKoduAra, this.hesapAdiAra).subscribe(res => {
      this.hesapPlani = res;
    });
  }

  kodSec(hesapKodu: string) {
    this.selectedHesapKodu.emit(hesapKodu);
    $('#hesap-kodu-sec-modal').modal('hide');
  }

  private reset() {
    this.hesapKoduAra = '';
    this.hesapAdiAra = '';
    this.hesapPlani = null;
  }
}
